export default "/strshell-shell.1d8af1850e97862d507230b8da029389.svg";